import * as React from "react"
import {GlobalNavContextInfo} from "./GlobalNav"

export enum PopupType {
  PRODUCT,
  USER,
  ACCOUNTS_MODAL,
  NOTIFICATION,
  APPS
}

export interface GlobalNavPopup {
  openPopup: PopupType | null
  setOpenPopup: (PopupType) => void
}

const DEFAULT = {
  openPopup: null,
  setOpenPopup: (_) => {}
}

const GlobalNavPopupContext = React.createContext<GlobalNavPopup>(DEFAULT)

export default GlobalNavPopupContext